import { render, staticRenderFns } from "./generar_orden_compra_directamente.vue?vue&type=template&id=6415ae8c&lang=pug&"
import script from "./generar_orden_compra_directamente.vue?vue&type=script&lang=js&"
export * from "./generar_orden_compra_directamente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports